import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import styles from './BoardView.module.css';

import Button from "../../components/Button";
import Tag from "../../components/Tag";
import Checkbox from "../../components/Checkbox";
import { useNavigate, useParams } from "react-router-dom";
import { fetchImageList, getPanelList, getQCRequests, updatePanelStatus, updateQCRequest, getRejectionList } from "../../services/qcService";
import MaterialIconsReact from "material-icons-react";
import BarcodeScanner from "../../helpers/BarcodeScanner";
import SubHeader from "../../components/SubHeader";
import Modal from "../../components/Modal";
import InfoMessage from "../../components/InfoMessage";
import { TabsWrapper } from "../../components/Tabs";
import { Tab, TabList, TabPanel } from 'react-tabs';
import { ImageTab } from "./ImageTab";
import Loader from "../../components/Loader";

function PanelListView() {
  const {selectedLocation, currentFactory, toastList, setToastList, setTopHeader, topHeader, setShowLoadingFull} = useContext(UserContext);
  const params = useParams();

  const [panelList, setPanelList] = useState({});
  const [selectedPanel, setSelectedPanel] = useState({});
  const [selectedPanelCount, setSelectedPanelCount] = useState(0);
  const [binNumber, setBinNumber] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [category, setCategory] = useState('Pressing');
  const [reasonList, setReasonList] = useState({});
  const [scannedPanel, setScannedPanel] = useState(undefined);
  const [isQCOpen, setIsQCOpen] = useState(false);
  const navigate = useNavigate();
  const [rejectionReasons, setRejectionReasons] = useState({});

  useEffect(() => {
    showPanelDetails(params.po_code);
    // setTopHeader({
    //   mainHeader: false,
    //   subHeader: true
    // })
    getAllQCRequests(params.po_code);
    getRejectionReasons();

    // return () => {
    //   setTopHeader({
    //     mainHeader: true,
    //     subHeader: false
    //   })
    // }
  }, [params.po_code])

  useEffect(() => {
    initializeBarCodeListener();
    return () => removeBarCodeListener()
  }, [])

  const handleScanListener = (event) => {
    onBarcodeScan(event.detail);
  }

  const initializeBarCodeListener = () => {
    BarcodeScanner.initialize();
    document.addEventListener('onbarcodescanned', handleScanListener)
  }

  const removeBarCodeListener = () => {
    document.removeEventListener('onbarcodescanned', handleScanListener)
    BarcodeScanner.close()
  }

  const onBarcodeScan = (barcode) => {
    if (!isQCOpen) {
      showToast({type: 'error', message: 'Kindly raise QC number before proceeding QC check!', autoClose: false});
      return;
    }
    setScannedPanel(barcode);
    setShowRejectPopup(true);
  }

  const handlePanelStatus = async (status) => {
    setShowLoadingFull(true);
    try {
      let payload = {
        "panels": scannedPanel || Object.keys(selectedPanel),
        "status": status,
      }
      if (status === 'rejected') {
        payload["rejected_reasons"] = Object.keys(reasonList)
      }
      const response = await updatePanelStatus({
        "po_code": params.po_code,
        "factory_code": currentFactory.item_code,
        payload
      })
      if (response.status !== 200) {
        showToast({type: 'error', message: response.message || 'Internal server error. Kindly try again!', autoClose: false});
      } else {
        showToast({type: 'success', message: status === 'approved' ? 'Selected panels were approved successfully!' : 'Selected panels were rejected successfully!', autoClose: false});
        // let tempPanelList = {...panelList};
        // tempPanelList.parts = tempPanelList.parts.map((item) => {
        //   if (selectedPanel[item]) {
        //     item.status = status
        //   }
        //   return item;
        // })
        // setPanelList(tempPanelList);
        showPanelDetails(params.po_code);
        setSelectedPanel({});
        setSelectedPanelCount(0);
        onRejectionModalClose()
      }
    } catch (err) {
      showToast({type: 'error', message: err.message || 'Internal server error. Kindly try again!', autoClose: false});
    }
    setShowLoadingFull(false);
  }

  const showPanelDetails = async (po_code) => {
    let payload = {
      factory_code: currentFactory.item_code,
      location: selectedLocation.location,
      po_code: po_code,
      sorted_panels: false
    }
    try {
      const response = await getPanelList(payload);
      if (response.status !== 200) {
        showToast({type: 'error', message: response.message || 'Internal server error. Kindly try again!', autoClose: false});
      } else {
        let binList = {}
        response.message.parts.map(part => {
          if (part.bin !== 0) {
            binList[part.bin] = true;
          }
        })
        setPanelList(response.message);
        setBinNumber(Object.keys(binList).join(', '))
        return response.message;
      }
    } catch (err) {
      showToast({type: 'error', message: err.message || 'Internal server error. Kindly try again!', autoClose: false});
    }
  }

  const showToast = ({type, message, action, autoClose = true}) => {
    // show toast message
    let toast = {
      type: type,
      text: message,
      onClick: action ? () => console.log('button clicked') : undefined,
      autoClose: autoClose
    }
    setToastList([...toastList, toast]);
  }

  const handleCheckbox = (panel) => {
    let panelListTemp = {...selectedPanel}
    if (panelListTemp[panel]) {
      delete panelListTemp[panel];
    } else {
      panelListTemp[panel] = true;
    }
    setSelectedPanel(panelListTemp);
    setSelectedPanelCount(selectedPanelCount + (selectedPanel[panel] ? -1 : 1));
  }

  const approvePanels = async () => {
    await handlePanelStatus('approved')
  }

  const rejectPanels = () => {
    setShowRejectPopup(true);
  }

  const handleQCComplete = async () => {
    setShowLoadingFull(true);
    setShowConfirm(false);
    try {
      const imageList = await fetchImageList(params.po_code);
      if (imageList.status === 200) {
        if (!imageList.message || imageList.message.length === 0) {
          showToast({type: 'error', message: 'Kindly upload panel images to complete QC', autoClose: false});
        } else {
          const response = await updateQCRequest({
            po_code: params.po_code,
            factory_code: currentFactory.item_code,
            status: 'completed'
          })
          if (response.status !== 200) {
            showToast({type: 'error', message: response.message || 'Internal server error. Kindly try again!', autoClose: false});
          } else {
            showToast({type: 'success', message: `QC process successfully completed for ${params.po_code}`, autoClose: false});
            navigate(`/dashboard/qccheck`);
          }
        }
      } else {
        showToast({type: 'error', message: imageList.message, autoClose: false});
      }
    } catch (e) { 
      showToast({type: 'error', message: 'Unable to complete QC. Kindly try again!', autoClose: false});
    }
    setShowLoadingFull(false);
  }

  const handleReasonCheckbox = (category, reason) => {    
    let reasonsTemp = {...reasonList};
    if (reasonsTemp[category + ':' + reason]) {
      delete reasonsTemp[category + ':' + reason];
    } else {
      reasonsTemp[category + ':' + reason] = true;
    }
    setReasonList(reasonsTemp);
  }

  const onSaveRejection = async () => {
    await handlePanelStatus('rejected')
  }

  const onRejectionModalClose = () => {
    setReasonList({});
    setShowRejectPopup(false);
    setScannedPanel(undefined);
  }

  const getReasonCount = (category) => {
    let result = Object.keys(reasonList).reduce((count, curr) => {
      if (curr.split(':')[0] === category.toUpperCase()) {
        count++;
      }
      return count;
    }, 0)
    return result || ''
  }

  const getAllQCRequests = async (po_code) => {
    const qcList = await getQCRequests({
      po_code,
      factory_code: currentFactory.item_code
    })
    if (qcList.status === 200) {
      let qcOpen = false;
      if (qcList.message && qcList.message.length > 0) {
        qcList.message.map((qcrequest) => {
          if (qcrequest.status.toLowerCase() === 'pending' || qcrequest.status.toLowerCase() === 'rework') {
            qcOpen = true;
            return;
          }
        })
      } else {
        qcOpen = false;
      }
      setIsQCOpen(qcOpen)
    } else {
      showToast({type: 'error', message: qcList.message || 'Internal Server Error', autoClose: false});
    }
  }

  const getRejectionReasons = async () => {
    const reasonList = await getRejectionList();
    setRejectionReasons(reasonList);
  }

  return (
    <>
      <SubHeader 
        showBackButton={true} 
        onBack={() => navigate(`/dashboard/qccheck`)} 
        subTitle={params.po_code}
        right={<div className={styles.flexBlock}>
          <div>Bin Location: <span style={{fontWeight: 'bold', marginRight: '24px'}}>{binNumber || '-'}</span></div>
          <Button type="primary" fillStyle="filled" onClick={() => setShowConfirm(true)} disabled={!isQCOpen}>Done QC</Button>
        </div>} 
      ></SubHeader>
      <TabsWrapper className={styles.tabContainer}>
        <TabList className={'react-tabs__tab-list ' + styles.tabList}>
          <Tab>Panel List</Tab>
          <Tab>Images</Tab>
        </TabList>
        <TabPanel>
          <div className="p-24">
            <InfoMessage message='Scan a panel to reject'></InfoMessage>
            <div className={styles.boardHeader}>
              <div className={styles.alignCenter}>
                <span style={{fontWeight: 700}}>Panel List</span> 
                <span className="ft-12" style={{fontWeight: 400, marginLeft: '4px', color: '#666666'}}>({panelList.total_parts_for_po})</span>
              </div>
            </div>
            {selectedPanelCount > 0 && <div className={styles.mb16 + ' ' + styles.alignCenter}>
              <span>{selectedPanelCount} selected</span>
              <Button type="tertiaryGreen" style={{marginLeft: '8px'}} className={styles.alignCenter} onClick={approvePanels}>
                <MaterialIconsReact icon='check' size={20}></MaterialIconsReact>
                <span style={{marginLeft: '8px'}}>Approve Panel</span>
              </Button>
              <Button type="tertiaryRed" fillStyle={'outline'} style={{marginLeft: '8px'}} className={styles.alignCenter} onClick={rejectPanels}>
                <MaterialIconsReact icon='close' size={20}></MaterialIconsReact>
                <span style={{marginLeft: '8px'}}>Reject Panel</span>
              </Button>
            </div>}
            <div className="table-responsive">
              <table className="table block">
                <thead>
                  <tr>
                    <th className="ft-12"></th>
                    <th className="ft-12">PANEL CODE</th>
                    <th className="ft-12">MATERIAL</th>
                    <th className="ft-12">FINISH SIZE (l*w*t)</th>
                    <th className="ft-12">STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {panelList && panelList.parts && panelList.parts.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td><Checkbox disabled={!isQCOpen} checked={selectedPanel[item.part] === true} onChange={() => handleCheckbox(item.part)}></Checkbox></td>
                        <td>{item.part}</td>
                        <td>{item.partdetail.material_desc}</td>
                        <td>{item.partdetail.cut_length + '*' + item.partdetail.cut_width + '*' + item.partdetail.cut_thick}</td>
                        <td>
                          {item.status && (item.status === 'pending' ? 
                          <Tag type='tertiary' fillStyle='filled'>Pending</Tag> : 
                          (item.status === 'approved' ? <Tag type='primary' fillStyle='outline' icon={'check_circle'}>Approved</Tag> : 
                            <Tag type='tertiaryRed' fillStyle='outline' icon={'check_circle'}>Rejected</Tag>
                          )) }
                          {!item.status && <Tag type='tertiary' fillStyle='filled'>Not Sorted</Tag>}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
          {showRejectPopup && 
          <Modal 
            title={'Select rejection reason'} 
            onClose={onRejectionModalClose} 
            primaryAction={onSaveRejection}
            primaryTitle={'Save'}
            modalContentStyle={{padding: 0}}
          >
            {Object.keys(rejectionReasons).length > 0 && <div className={styles.rejectionContentWrapper}>
              <div className={styles.leftContent}>
                <div>
                  {Object.keys(rejectionReasons).map((item, i) => {
                    return (<div className={styles.rcategory + ' ' + (category === item ? styles.selectedCategory : '')} onClick={() => setCategory(item)} key={i}>
                      <span>{item}</span>
                      <span className={styles.reasonCount}>{getReasonCount(item)}</span>
                    </div>)
                  })}
                </div>
              </div>
              <div className={styles.rightContent}>
                <div className={styles.rejectionWrapper}>
                  {rejectionReasons[category].map((item, i) => {
                    return <div key={i} className={styles.reasonitem}>
                      <Checkbox checked={reasonList[category.toUpperCase() + ':' + item]} label={item} onChange={() => handleReasonCheckbox(category.toUpperCase(), item)}></Checkbox>
                    </div>
                  })}
                </div>
              </div>
            </div>}
            {Object.keys(rejectionReasons).length === 0 && 
              <div className={styles.rejectionContentWrapper}>
                <Loader tip='Fetching reasons list. If its taking more time, kindly reload the page.'></Loader>
              </div>}
          </Modal>}
        </TabPanel>
        <TabPanel>
          <ImageTab></ImageTab>
        </TabPanel>
      </TabsWrapper>
      {showConfirm && <Modal title={'Confirm'} primaryTitle={'Done QC'} onClose={() => setShowConfirm(false)} primaryAction={handleQCComplete}>
        <div>Are you sure you want to complete QC and approve remaining panels?</div>
      </Modal>}
    </>
  );
}

export default PanelListView;
